import styled from "@emotion/styled";

export const ScrollBar = styled.div({
    zIndex: 1000,
    overflowX: "auto",
    position: "fixed",
    width: "100%",
    bottom: 0,
});

export const ScrollbarChild = styled.div({
    height: 1,
});

export const arrowVisibleClassName = "visible";

export const Arrow = styled.div(_ => ({
    position: "absolute",
    opacity: 0,
    pointerEvents: "none",
    transition: "opacity 0.1s ease-in",
    zIndex: 1000,

    [`&.${arrowVisibleClassName}`]: {
        pointerEvents: "all",
        opacity: 1,
    },
}));

export const ScrollableContainer2Root = styled.div({
    width: "100%",
    position: "relative",
    overflow: "hidden",
});

export const Root = styled.div({
    width: "100%",
    boxSizing: "border-box",
    overflowX: "auto",
});
